// Custom Element
if (!customElements.get("fabric-request-form")) {
  class FabricRequestForm extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    isDebugMode() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.has("debug");
    }

    init() {
      this.form = this.querySelector("form");
      this.form_action = this.form.action;
      //   this.form.action = "";
      this.submit_button = this.form.querySelector("#contactFormSubmit");
      this.selected_fabrics_input = document.querySelector("#selected_fabrics");
      this.swatch_selection_message = document.querySelector(
        "#swatch-selection-message"
      );
      this.selected_fabrics_list = document.querySelector(
        "#selectedFabricsList"
      );

      // this.form.addEventListener('submit', this.handleSubmit.bind(this));
      this.submit_button.addEventListener(
        "click",
        this.handleSubmit.bind(this)
      );

      // Use MutationObserver to detect programmatic changes to the input value
      const observer = new MutationObserver((mutations) => {
        this.validateSwatchSelection();
        this.updateSelectedFabricsList();
      });

      observer.observe(this.selected_fabrics_input, {
        attributes: true,
        attributeFilter: ["value"],
        characterData: true,
        subtree: true,
      });

      // Create a proxy for the native value setter
      const originalDescriptor = Object.getOwnPropertyDescriptor(
        HTMLInputElement.prototype,
        "value"
      );
      const that = this;

      Object.defineProperty(this.selected_fabrics_input, "value", {
        set(newValue) {
          const result = originalDescriptor.set.call(this, newValue);
          that.validateSwatchSelection();
          that.updateSelectedFabricsList();
          return result;
        },
        get() {
          return originalDescriptor.get.call(this);
        },
      });

      // Initialize Klaviyo
      this.initializeKlaviyo();

      // Set test values only in debug mode
      if (this.isDebugMode()) {
        this.setTestValues();
      }

      // Initial validation check
      this.validateSwatchSelection();
      this.updateSelectedFabricsList();
    }

    validateSwatchSelection() {
      const selectedFabrics = this.selected_fabrics_input.value.trim();

      if (selectedFabrics === "") {
        // No fabrics selected, show message and disable submit button
        this.swatch_selection_message.style.display = "block";
        this.submit_button.disabled = true;
      } else {
        // Fabrics selected, hide message and enable submit button
        this.swatch_selection_message.style.display = "none";
        this.submit_button.disabled = false;
      }
    }

    updateSelectedFabricsList() {
      // Clear the current list
      this.selected_fabrics_list.innerHTML = "";

      // Get the selected fabrics
      const selectedFabrics = this.selected_fabrics_input.value.trim();

      if (selectedFabrics) {
        // Split by comma and create list items
        const fabricsArray = selectedFabrics
          .split(",")
          .map((fabric) => fabric.trim());

        fabricsArray.forEach((fabric) => {
          if (fabric) {
            const listItem = document.createElement("li");
            listItem.textContent = fabric;
            listItem.style.backgroundColor = "#f0f0f0";
            listItem.style.padding = "5px 10px";
            listItem.style.borderRadius = "4px";
            this.selected_fabrics_list.appendChild(listItem);
          }
        });
      }
    }

    setTestValues() {
      // Generate random number for email
      const randomNum = Math.floor(Math.random() * 1000);

      // Set email
      const emailInput = this.form.querySelector(
        'input[name="contact[email]"]'
      );
      if (emailInput) {
        emailInput.value = `warren${randomNum}@haydonpower.co.uk`;
      }

      // Set phone (11 digits)
      const phoneInput = this.form.querySelector(
        'input[name="contact[phone]"]'
      );
      if (phoneInput) {
        phoneInput.value = "01234567890";
      }

      // Set name
      const nameInput = this.form.querySelector('input[name="contact[name]"]');
      if (nameInput) {
        nameInput.value = "Test User";
      }

      // Set address fields
      const address1Input = this.form.querySelector(
        'input[name="contact[Address 1]"]'
      );
      if (address1Input) {
        address1Input.value = "123 Test Street";
      }

      const address2Input = this.form.querySelector(
        'input[name="contact[Address 2]"]'
      );
      if (address2Input) {
        address2Input.value = "Test Building";
      }

      const townInput = this.form.querySelector(
        'input[name="contact[Town / City]"]'
      );
      if (townInput) {
        townInput.value = "Test City";
      }

      const postcodeInput = this.form.querySelector(
        'input[name="contact[Post Code]"]'
      );
      if (postcodeInput) {
        postcodeInput.value = "TE1 1ST";
      }

      // Set any dropdowns to first option
      const dropdowns = this.form.querySelectorAll("select");
      dropdowns.forEach((dropdown) => {
        if (dropdown.options.length > 1) {
          dropdown.selectedIndex = 1; // Skip the empty first option
        }
      });
    }

    initializeKlaviyo() {
      // Initialize Klaviyo queue
      // window._learnq = window._learnq || [];
      // Load Klaviyo script
      // const script = document.createElement('script');
      // script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=SbaiEQ';
      // script.async = true;
      // document.head.appendChild(script);
    }

    async handleSubmit(event) {
      event.preventDefault();
      event.stopPropagation();

      // Get form data
      const formData = new FormData(this.form);
      const formValues = Object.fromEntries(formData.entries());

      // Check if Klaviyo is available
      if (typeof klaviyo === "undefined") {
        console.error(
          "Klaviyo is not defined. Submitting form without Klaviyo integration."
        );
        return;
      }

      // Extract contact information
      const email = formValues["contact[email]"];
      const name = formValues["contact[name]"];
      const selectedFabrics = formValues["contact[Selected Fabrics]"];

      // Split name into first and last name
      const nameParts = name.split(" ");
      const firstName = nameParts[0];
      const lastName = nameParts.slice(1).join(" ");

      // Create timestamp for the swatch request
      const timestamp = new Date().toISOString();

      try {
        // 1. Create/update profile using AJAX instead of klaviyo.identify
        const profileData = {
          data: {
            type: "profile",
            attributes: {
              email: email,
              first_name: firstName,
              last_name: lastName,
              properties: {
                Swatch_Request: selectedFabrics,
              },
            },
          },
        };

        const profileResponse = await fetch(
          "https://a.klaviyo.com/client/profiles?company_id=SbaiEQ",
          {
            method: "POST",
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2025-01-15",
            },
            body: JSON.stringify(profileData),
          }
        );

        console.log("Klaviyo identify completed successfully");

        // Subscribe to the specific list

        const listId = "TPUgWi";
        const body = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                  id: "string",
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId,
                },
              },
            },
          },
        };
        const url =
          "https://a.klaviyo.com/client/subscriptions?company_id=SbaiEQ";
        const options = {
          method: "POST",
          headers: {
            accept: "application/vnd.api+json",
            revision: "2025-04-15",
            "content-type": "application/vnd.api+json",
          },
          body: JSON.stringify(body),
        };

        await fetch(url, options);

        // Track the swatch request as a custom event
        klaviyo.track("Swatch Request Submitted", {
          "Selected Fabrics": selectedFabrics,
          "Request Timestamp": timestamp,
        });

        console.log("Swatch request tracked successfully");
        console.log("All Klaviyo operations completed");

        // Restore form action and submit
        this.form.submit();
      } catch (error) {
        console.error("Error in Klaviyo integration:", error);
        console.error("Error details:", {
          message: error.message,
          stack: error.stack,
          name: error.name,
        });
      }
    }
  }

  customElements.define("fabric-request-form", FabricRequestForm);
}
